import React from 'react'
import { FormGroup, Label, Input, Button, Spinner } from 'reactstrap'
import FormCard from '../common/FormCard'

function UsersPasswordCard({
  formData,
  errors,
  submitted,
  isSaving,
  errorMessage,
  successMessage,
  onInputChange,
  onSubmit,
}
)


{
  return (
    <FormCard
      title="Cambiar contraseña"
      onSubmit={onSubmit}
      isSubmitting={isSaving}
      errorMessage={errorMessage}
      successMessage={successMessage}
      submitLabel="Actualizar contraseña"
    >
      <FormGroup>
        <Label for="newPassword">Nueva contraseña</Label>
        <Input
          type="password"
          name="newPassword"
          id="newPassword"
          placeholder="Introduce la nueva contraseña"
          value={formData.newPassword}
          onChange={onInputChange}
          invalid={submitted && !!errors.newPassword}
        />
        {submitted && errors.newPassword && (
          <div className="text-danger mt-1">{errors.newPassword}</div>
        )}
      </FormGroup>

      <FormGroup>
        <Label for="confirmPassword">Confirmar contraseña</Label>
        <Input
          type="password"
          name="confirmPassword"
          id="confirmPassword"
          placeholder="Confirma la nueva contraseña"
          value={formData.confirmPassword}
          onChange={onInputChange}
          invalid={submitted && !!errors.confirmPassword}
        />
        {submitted && errors.confirmPassword && (
          <div className="text-danger mt-1">{errors.confirmPassword}</div>
        )}
      </FormGroup>
    </FormCard>
  )
}

export default UsersPasswordCard
